import { useMemo } from "react";
import { useSelector } from "src/store";

const readPath = (source, path) => {
  if (!source || !path || typeof path !== "string") {
    return undefined;
  }

  return path.split(".").reduce((acc, key) => {
    if (acc && typeof acc === "object") {
      return acc[key];
    }
    return undefined;
  }, source);
};

const useSubscription = () => {
  const { currentCustomer } = useSelector((state) => state.customers);

  const plan = currentCustomer?.subscription_plan || null;
  const features = plan?.features || {};

  const planInclude = useMemo(() => {
    return (featurePath) => Boolean(readPath(features, featurePath));
  }, [features]);

  return {
    plan,
    features,
    hasPlan: Boolean(plan),
    planInclude,
  };
};

export default useSubscription;
